import { render, staticRenderFns } from "./CoownersList.vue?vue&type=template&id=2502ef7f"
import script from "./CoownersList.vue?vue&type=script&lang=ts"
export * from "./CoownersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports